<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fak"
			data-icon="details-icon"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
			class="uploaded-icon-preview svg-inline--fa fa-details-icon"
		>
			<path
				class="light"
				fill="currentColor"
				d="M216 320h240c9.466 0 17.142-7.164 17.142-16 0-8.8-7.715-16-17.142-16H216c-9.428 0-17.143 7.2-17.143 16s7.715 16 17.143 16zm0-96h240c9.427 0 17.142-7.2 17.142-16s-7.715-16-17.142-16H216c-9.428 0-17.143 7.2-17.143 16s7.715 16 17.143 16zm0 192h137.142c9.47 0 17.143-7.165 17.143-16 0-8.838-7.674-16-17.143-16H216c-9.428 0-17.143 7.2-17.143 16s7.715 16 17.143 16zM507.427 0H164.572C126.696 0 96 28.65 96 64v384c0 35.35 30.696 64 68.572 64h342.855C545.302 512 576 483.35 576 448V64c0-35.35-30.749-64-68.573-64zm34.288 448c0 17.642-15.385 32-34.288 32H164.572c-18.9 0-34.286-14.358-34.286-32V128h411.43v320zm0-352h-411.43V64c0-17.64 15.386-32 34.287-32h342.855c18.903 0 34.288 14.36 34.288 32v32z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'DetailsIcon',
	components: { Icon },
	props,
}
</script>
